"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessCriteriaForReportDataAddApi = accessCriteriaForReportDataAddApi;
exports.accessCriteriaForReportDataAddDonorApi = accessCriteriaForReportDataAddDonorApi;
exports.accessCriteriaForReportDataAddImpactApi = accessCriteriaForReportDataAddImpactApi;
exports.accessCriteriaForReportDataAddPerformanceApi = accessCriteriaForReportDataAddPerformanceApi;
exports.accessCriteriaForReportDataFetchApi = accessCriteriaForReportDataFetchApi;
exports.accessCriteriaForReportDataFetchDonorApi = accessCriteriaForReportDataFetchDonorApi;
exports.accessCriteriaForReportDataFetchImpactApi = accessCriteriaForReportDataFetchImpactApi;
exports.accessCriteriaForReportDataFetchPerformanceApi = accessCriteriaForReportDataFetchPerformanceApi;
exports.accessCriteriaForReportDataUpdateApi = accessCriteriaForReportDataUpdateApi;
exports.accessCriteriaForReportDataUpdateDonorApi = accessCriteriaForReportDataUpdateDonorApi;
exports.accessCriteriaForReportDataUpdateImpactApi = accessCriteriaForReportDataUpdateImpactApi;
exports.accessCriteriaForReportDataUpdatePerformanceApi = accessCriteriaForReportDataUpdatePerformanceApi;
exports.softDeleteDetailListApi = softDeleteDetailListApi;
exports.softDeleteDetailPermanentlyDeleteApi = softDeleteDetailPermanentlyDeleteApi;
exports.softDeleteDetailPermanentlyDeleteBulkApi = softDeleteDetailPermanentlyDeleteBulkApi;
exports.softDeleteDetailRestoreApi = softDeleteDetailRestoreApi;
exports.softDeleteDetailRestoreBulkApi = softDeleteDetailRestoreBulkApi;
exports.softDeleteDetailTemporaryDeleteApi = softDeleteDetailTemporaryDeleteApi;
exports.softDeleteDonorListApi = softDeleteDonorListApi;
exports.softDeleteDonorPermanentlyDeleteApi = softDeleteDonorPermanentlyDeleteApi;
exports.softDeleteDonorPermanentlyDeleteBulkApi = softDeleteDonorPermanentlyDeleteBulkApi;
exports.softDeleteDonorRestoreApi = softDeleteDonorRestoreApi;
exports.softDeleteDonorRestoreBulkApi = softDeleteDonorRestoreBulkApi;
exports.softDeleteDonorTemporaryDeleteApi = softDeleteDonorTemporaryDeleteApi;
exports.softDeleteImpactListApi = softDeleteImpactListApi;
exports.softDeleteImpactPermanentlyDeleteApi = softDeleteImpactPermanentlyDeleteApi;
exports.softDeleteImpactPermanentlyDeleteBulkApi = softDeleteImpactPermanentlyDeleteBulkApi;
exports.softDeleteImpactRestoreApi = softDeleteImpactRestoreApi;
exports.softDeleteImpactRestoreBulkApi = softDeleteImpactRestoreBulkApi;
exports.softDeleteImpactTemporaryDeleteApi = softDeleteImpactTemporaryDeleteApi;
exports.softDeletePerformanceListApi = softDeletePerformanceListApi;
exports.softDeletePerformancePermanentlyDeleteApi = softDeletePerformancePermanentlyDeleteApi;
exports.softDeletePerformancePermanentlyDeleteBulkApi = softDeletePerformancePermanentlyDeleteBulkApi;
exports.softDeletePerformanceRestoreApi = softDeletePerformanceRestoreApi;
exports.softDeletePerformanceRestoreBulkApi = softDeletePerformanceRestoreBulkApi;
exports.softDeletePerformanceTemporaryDeleteApi = softDeletePerformanceTemporaryDeleteApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function accessCriteriaForReportDataFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.fetch), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function accessCriteriaForReportDataAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.add), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function accessCriteriaForReportDataUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.update), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function accessCriteriaForReportDataFetchDonorApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.fetchDonor), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function accessCriteriaForReportDataAddDonorApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.addDonor), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function accessCriteriaForReportDataUpdateDonorApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.updateDonor), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function accessCriteriaForReportDataFetchPerformanceApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.fetchPerformance), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function accessCriteriaForReportDataAddPerformanceApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.addPerformance), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function accessCriteriaForReportDataUpdatePerformanceApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.updatePerformance), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function accessCriteriaForReportDataFetchImpactApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.fetchImpact), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function accessCriteriaForReportDataAddImpactApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.addImpact), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function accessCriteriaForReportDataUpdateImpactApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaForReportData.updateImpact), params);
}

// Detail Section
/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailTemporaryDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailTemporaryDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailListApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailPermanentlyDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailPermanentlyDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailPermanentlyDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailPermanentlyDeleteBulkApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailRestoreApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDetailRestoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDetailRestoreBulkApi), params);
}

// Performance Section
/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformanceTemporaryDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformanceTemporaryDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformanceListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformanceListApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformancePermanentlyDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformancePermanentlyDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformancePermanentlyDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformancePermanentlyDeleteBulkApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformanceRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformanceRestoreApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeletePerformanceRestoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeletePerformanceRestoreBulkApi), params);
}

// Donor Section
/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorTemporaryDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorTemporaryDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorListApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorPermanentlyDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorPermanentlyDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorPermanentlyDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorPermanentlyDeleteBulkApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorRestoreApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteDonorRestoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteDonorRestoreBulkApi), params);
}

// Impact Section
/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactTemporaryDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactTemporaryDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactListApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactPermanentlyDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactPermanentlyDeleteApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactPermanentlyDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactPermanentlyDeleteBulkApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactRestoreApi), params);
}

/**
 * soft delete for report data
 * @param payload
 * @returns api response
 * @description this function used for soft delete.
 */
function softDeleteImpactRestoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.accessCriteriaSoftDeleteForReportData.softDeleteImpactRestoreBulkApi), params);
}